/* Hide attachment and action controls when voice recording is active. The recorder's controller
   puts is-voice-recording on its form (voice/recording/button_component_controller.js). This used to be a :has(.voice-recording-button--recording)
   on the component: paired with the classless `> :not(...)` below, it made every DOM insert on the
   page restyle the whole document, which froze admin for seconds during chart redraws. */
.new-contribution-component .is-voice-recording {
  .new-contribution-component__footer-left,
  .voice-recording-button {
    @apply w-full;
  }

  .new-contribution-component__footer-left > *:not(.voice-recording-button),
  .new-contribution-component__footer-actions {
    @apply hidden;
  }
}
